import { __assign, __extends } from "tslib";
import React, { Component } from 'react';
import MobileZoomImage from './mobileZoomImage';
import MobileZoomText from './mobileZoomText';
import Pincher from './pincher';
var MobileZoom = /** @class */ (function (_super) {
    __extends(MobileZoom, _super);
    function MobileZoom(props) {
        return _super.call(this, props) || this;
    }
    MobileZoom.prototype.componentDidMount = function () {
        this.pincher = new Pincher({
            container: this.props.container,
            allowSwipe: false,
            allowPinch: true,
            toggleZoom: this.props.actions.toggleZoom,
            fullscreenItem: this.props.current.item,
        });
        this.pincher.update();
    };
    MobileZoom.prototype.getItemWrapperStyle = function () {
        var initialOffset = this.props.initialOffset;
        var _a = this.props.current.item, height = _a.height, width = _a.width;
        var dimenstions = {
            height: height,
            width: width,
            position: 'relative',
        };
        var style = __assign({ position: 'absolute' }, (initialOffset
            ? __assign(__assign({}, dimenstions), { top: initialOffset }) : {
            height: '100%',
            width: '100%',
        }));
        return style;
    };
    MobileZoom.prototype.getItem = function () {
        var item = this.props.current.item;
        var currentGalleryItem = this.props.currentGalleryItem;
        if (item.type === 'image') {
            return (React.createElement(MobileZoomImage, { resizedUrl: currentGalleryItem.resizedImageSrc, item: item, currentWindow: this.props.currentWindow }));
        }
        else if (item.type === 'text') {
            return (React.createElement(MobileZoomText, { item: item, currentWindow: this.props.currentWindow }));
        }
    };
    MobileZoom.prototype.getCloseButton = function () {
        var actions = this.props.actions;
        return (React.createElement("button", { style: { zIndex: 1000 }, className: "fullscreen-icon fullscreen-toggle-zoom progallery-svg-font-icons-close-x ", onClick: function () { return actions.toggleZoom(false); } },
            React.createElement("div", { className: "icon-background" })));
    };
    MobileZoom.prototype.render = function () {
        return (React.createElement("div", { className: "mobile-zoom-container", style: {
                height: '100%',
                width: '100%',
                position: 'absolute',
                zIndex: 9999,
            } },
            this.getCloseButton(),
            React.createElement("div", { className: "mobile-zoom-item-wrapper", style: this.getItemWrapperStyle() }, this.getItem())));
    };
    return MobileZoom;
}(Component));
export default MobileZoom;
// https://izaaca.wixsite.com/mysite-16?petri_ovr=specs.ExcludeSiteFromSsr%3Atrue&widgetsUrlOverride=142bb34d-3439-576a-7118-683e690a1e0d=https://localhost:3200/viewer.bundle.js
// https://izaaca.wixsite.com/mysite-16?petri_ovr=specs.ExcludeSiteFromSsr%3Atrue&widgetsUrlOverride=142bb34d-3439-576a-7118-683e690a1e0d=https://localhost:3200/viewer.bundle.js
// https://supportqa.wixsite.com/phot-1769?petri_ovr=specs.ExcludeSiteFromSsr%3Atrue&widgetsUrlOverride=142bb34d-3439-576a-7118-683e690a1e0d=https://localhost:3200/viewer.bundle.js
// art store
// https://izaaca.wixsite.com/mysite-1/art-store?petri_ovr=specs.ExcludeSiteFromSsr%3Atrue&widgetsUrlOverride=142bb34d-3439-576a-7118-683e690a1e0d=https://localhost:3200/viewer.bundle.js
// art-store
// https://izaaca.wixsite.com/mysite-1/art-store?petri_ovr=specs.ExcludeSiteFromSsr%3Atrue&widgetsUrlOverride=142bb34d-3439-576a-7118-683e690a1e0d=https://localhost:3200/viewer.bundle.js
// https://izaaca.wixsite.com/mysite-16?petri_ovr=specs.ExcludeSiteFromSsr%3Atrue&widgetsUrlOverride=142bb34d-3439-576a-7118-683e690a1e0d=https://localhost:3200/viewer.bundle.js
// jira
// https://supportqa.wixsite.com/phot-1769?petri_ovr=specs.ExcludeSiteFromSsr%3Atrue&widgetsUrlOverride=142bb34d-3439-576a-7118-683e690a1e0d=https://localhost:3200/viewer.bundle.js
//# sourceMappingURL=MobileZoom.js.map